<h6 class="FAQTopics__title">{{ title }}</h6>

@for (topic of topics; track topic) {
  <section class="FAQTopic">
    <h6 class="FAQTopic__title">{{ topic.name }}</h6>
    @for (faq of topic.faqs; track faq) {
      <section class="FAQ">
        <p class="FAQ__question">{{ faq.question }}</p>
        <expanding-article [text]="faq.answer"></expanding-article>
      </section>
    }
  </section>
}
